import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=452da453&scoped=true&"
import script from "./myAccount.vue?vue&type=script&lang=js&"
export * from "./myAccount.vue?vue&type=script&lang=js&"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=452da453&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452da453",
  null
  
)

export default component.exports